import {SaleVehicleAlbumPhotoResponseBodySaleVehiclePhoto} from '@dms/api/vehicle';

import {UnifiedAlbumImage} from '../types/UnifiedAlbumImage';

export const toUnifiedAlbumImage = (
  image: SaleVehicleAlbumPhotoResponseBodySaleVehiclePhoto
): UnifiedAlbumImage => ({
  ...image,
  url: image.url.replace('/get/', '/resize/'),
  isPromoPhoto: false,
});
